import { STATIC_FIELDS, calculateSpecialField } from './common';
import { hasProperty } from '../../../util/jquery';

export const marketSnapshotransforms = data => {
    const statics = [];
    data = data.Data;
    if (!data) {
        return statics;
    }
    data.forEach(items => {
        let [field, ticker] = [[], ''];
        const lastTradeDate =
            items.priceLastTradeDate ||
            items.navLastTradeDate ||
            items.ctLastTradeDate;
        if (lastTradeDate) {
            items.lastTradeDate = lastTradeDate;
            field.push(calculateSpecialField(items, 'lastTradeDate'));
        }
        for (const item in items) {
            if (item === 'ticker') {
                ticker = items[item];
            } else if (hasProperty(STATIC_FIELDS, item.toUpperCase())) {
                field.push(calculateSpecialField(items, item));
            }
        }
        statics.push({
            snapshot: field,
            ticker
        });
    });
    return statics;
};
